var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DefaultLayout,{attrs:{"salesMenu":true,"obtainOrderMenu":true}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"7"}},[_c(_setup.ProjectSearch)],1),_c('v-col',{attrs:{"cols":"12","sm":"5"}},[_c(_setup.ProjectProgress)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }